/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetOptions200ResponseData
 */
export interface GetOptions200ResponseData {
  /**
   * Адрес
   * @type {string}
   * @memberof GetOptions200ResponseData
   */
  address: string | null
  /**
   * Контакт Telegram
   * @type {string}
   * @memberof GetOptions200ResponseData
   */
  telegram: string | null
  /**
   * Время работы
   * @type {string}
   * @memberof GetOptions200ResponseData
   */
  workTime: string | null
  /**
   * Контактный телефон
   * @type {string}
   * @memberof GetOptions200ResponseData
   */
  phone: string | null
  /**
   * Контакт WhatsApp
   * @type {string}
   * @memberof GetOptions200ResponseData
   */
  whatsapp: string | null
  /**
   * Контакт MAX
   * @type {string}
   * @memberof GetOptions200ResponseData
   */
  max: string | null
}

/**
 * Check if a given object implements the GetOptions200ResponseData interface.
 */
export function instanceOfGetOptions200ResponseData(
  value: object
): value is GetOptions200ResponseData {
  if (!('address' in value) || value['address'] === undefined) return false
  if (!('telegram' in value) || value['telegram'] === undefined) return false
  if (!('workTime' in value) || value['workTime'] === undefined) return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  if (!('whatsapp' in value) || value['whatsapp'] === undefined) return false
  if (!('max' in value) || value['max'] === undefined) return false
  return true
}

export function GetOptions200ResponseDataFromJSON(
  json: any
): GetOptions200ResponseData {
  return GetOptions200ResponseDataFromJSONTyped(json, false)
}

export function GetOptions200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOptions200ResponseData {
  if (json == null) {
    return json
  }
  return {
    address: json['address'],
    telegram: json['telegram'],
    workTime: json['workTime'],
    phone: json['phone'],
    whatsapp: json['whatsapp'],
    max: json['max'],
  }
}

export function GetOptions200ResponseDataToJSON(
  value?: GetOptions200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    address: value['address'],
    telegram: value['telegram'],
    workTime: value['workTime'],
    phone: value['phone'],
    whatsapp: value['whatsapp'],
    max: value['max'],
  }
}
